module.exports = __webpack_public_path__ + "assets/img/banner.84c8a8cf.jpg";